import styled from "@emotion/styled";
import {
    fontSizes,
    fontWeights,
    gutterSizes,
    lineHeights,
} from "@gumtree/ui-library/src/base/theme";

export const StyledListViewContainer = styled.div`
    display: flex;
    flex-direction: column;
`;

export const StyledBlockTitle = styled.div`
    font-size: ${fontSizes.header};
    font-weight: ${fontWeights.bold};
    line-height: ${lineHeights.medium};
    margin-bottom: ${gutterSizes.large};
`;
